import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7b69d0a8"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "亲爱的各位用户：", -1));

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content start"
}, " 感谢您一直以来给予“漂流瓶交友”APP的支持与厚爱!由于公司业务发展战略调整，即日起“漂流瓶交友\"APP运营主体由广州鑫盛计算机科技有限公司变更为广州颜如玉网络有限公司，其一切业务及服务照常进行，所有客户及服务不受影响，新运营主体将一如既往为广大用户提供优质服务。 ", -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "content start"
}, "感谢您一直以来对于鑫盛计算机科技的信任与支持，由此给您带来的不便，敬请谅解!", -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right-name"
}, [/*#__PURE__*/_createTextVNode(" 广州鑫盛计算机科技有限公司"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 广州颜如玉网络有限公司"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 2024年11月8号"), /*#__PURE__*/_createElementVNode("br")], -1));

const _hoisted_5 = [_hoisted_1, _hoisted_2, _hoisted_3, _hoisted_4];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("div", {
    class: "hello",
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    (...args) => $setup.hideTip && $setup.hideTip(...args))
  }, _hoisted_5, 512), [[_vShow, $setup.show]]), _withDirectives(_createElementVNode("div", {
    class: "back",
    onClick: _cache[1] || (_cache[1] = //@ts-ignore
    (...args) => $setup.hideTip && $setup.hideTip(...args))
  }, null, 512), [[_vShow, $setup.show]])], 64);
}